<template>
  <div class="comment__audit-compare-content comment__item-sprint-content">
    <span class="is-opacity"> {{ itemTypeBacklogLabel("before") }} Backlog </span>
    <icon
      data="@icon/arrow-to.svg"
      :fill="true"
      width="var(--icon-24)"
      height="var(--icon-24)"
      color="var(--monochrome05to04)"
    />
    <span> {{ itemTypeBacklogLabel("after") }} Backlog </span>
  </div>
</template>

<script setup lang="ts">
import { Comment } from "@/models"
import { $t } from "@/plugins/i18n"

const props = defineProps<{
  comment: Comment
}>()

function itemTypeBacklogLabel(state: "before" | "after") {
  const selectedState = props.comment[state]
  if (selectedState?.backlogPriority == null) return "Unprioritized"
  return $t(`backlog.itemTypeToBacklogName.${selectedState.itemType}`)
}
</script>
